import { render, staticRenderFns } from "./RelatorioCanceladosListConcluidos.vue?vue&type=template&id=1940f34a"
import script from "./RelatorioCanceladosListConcluidos.vue?vue&type=script&lang=js"
export * from "./RelatorioCanceladosListConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports